import React, { useEffect } from 'react'
import { useRouter } from 'next/router'

import { historyUtils } from '@wartek-id/toolbox-helper'

import Header from 'app/BCKSPage/components/Header'
import { useAuth } from 'utils/auth'
import { SelectionStepsV2 } from '../components/SelectionSteps/SelectionStepsV2'
import AndroidHandler from 'utils/androidHandler'
import useKSPSTrackEvent from 'app/BCKSPage/hooks/useKSPSTrackEvent'
import BCKSProfile from 'app/BCKSPage/components/BCKSProfile'

export const KSDocPrecollection = () => {
  const androidHandler = AndroidHandler()
  const { session } = useAuth()
  const { KSPSTrackEvent } = useKSPSTrackEvent()

  const router = useRouter()
  const { user } = session

  if (!user) {
    router.replace('/home')
  }

  const handleBackClick = () => {
    if (androidHandler.enabled)
      historyUtils.backToApp(() => router.replace('/home'))
    else router.replace('/home')
  }

  useEffect(() => {
    KSPSTrackEvent({
      event_name: 'enter_ks_selection_process_page',
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="min-h-screen max-w-xl mx-auto bg-surface-subdued">
      <Header title="Proses Seleksi" onBackClick={handleBackClick} />

      <BCKSProfile className="border-b" />

      <div className="p-4 h-full">
        <SelectionStepsV2 />
      </div>
    </div>
  )
}
